package anjuros.development.components

import androidx.compose.runtime.Composable
import anjuros.development.modules.Theme
import anjuros.development.util.RoomZoomImageStyle
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun RoomZoomView(
    modifier: Modifier,
    imageZoomed: String,
    onLeftClicked: () -> Unit,
    onRightClicked: () -> Unit,
    onExitClicked: () -> Unit
) {


    Box(
        modifier = modifier.fillMaxSize()
            .visibility(if (imageZoomed.isNotEmpty()) Visibility.Visible else Visibility.Hidden)
            .backgroundColor(Theme.OpacityPrimary2.rgb)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().align(Alignment.Center),
            horizontalArrangement = Arrangement.SpaceAround,
            verticalAlignment = Alignment.CenterVertically
        ) {
            FaChevronLeft(
                size = IconSize.XXL,
                modifier = Modifier.color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .onClick { onLeftClicked() })

            Box(modifier = RoomZoomImageStyle.toModifier()) {

                Image(
                    src = imageZoomed,
                    alt = "Pokoje koło Białki Tatrzańskiej",
                    modifier = RoomZoomImageStyle.toModifier().objectFit(ObjectFit.Cover)
                )

            }


            FaChevronRight(
                size = IconSize.XXL,
                modifier = Modifier.color(Colors.White)
                    .cursor(Cursor.Pointer)
                    .onClick { onRightClicked() })
        }


        FaXmark(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .margin(top = 40.px, right = 20.px)
                .cursor(Cursor.Pointer)
                .color(Colors.White)
                .onClick { onExitClicked() },
            size = IconSize.XXL
        )
    }
}